// extracted by mini-css-extract-plugin
module.exports = {"catalog":"catalog-section_catalog__qzrnj","label":"catalog-section_label__51nqq","heading":"catalog-section_heading__HiJJu","cards":"catalog-section_cards__BQdDu"};